import React, { useRef } from 'react';
import { Button } from 'antd';
import { Formik } from 'formik';
import { Form, Input } from 'formik-antd';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';

import { BaseModal, BaseModalFooter } from 'components/wrappers/BaseModal';
import FormItem from 'components/formik/FormItem';
import SubmitButton from 'components/formik/SubmitButton';
import BaseAlert from 'components/wrappers/BaseAlert';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { ApiErrorMessage } from 'constants/ErrorMessages';
import useModalCloseOnNavigate from 'hooks/useModalCloseOnNavigate';
import { connectBullhornAccount } from 'redux/reducers/authenticationSlice';

import bullhornLogo from 'assets/img/bullhorn.svg';

import styles from './BullhornConnectModal.module.less';

type Props = {
  onClose: () => void;
};

const requiredMessage = 'Field is required';

const validationSchema = Yup.object({
  login: Yup.string()
    .max(50, 'Username should be 50 characters maximum')
    .required(requiredMessage),
  password: Yup.string()
    .required(requiredMessage)
    .max(50, 'Password should be 50 characters maximum'),
});

interface FormValues {
  login: string;
  password: string;
}

const initialValues: FormValues = {
  login: '',
  password: '',
};

export default function BullhornConnectModal(props: Props) {
  const { onClose } = props;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const formRef: any = useRef();

  useModalCloseOnNavigate(onClose);

  const handleCloseModal = () => {
    onClose();
  };

  const handleSubmit = async (values: FormValues) => {
    const result = await dispatch(connectBullhornAccount(values));

    if (connectBullhornAccount.fulfilled.match(result)) {
      BaseAlert.success('Your Bullhorn account was successfully connected.');
      navigate('/placements', { replace: true });
    } else {
      BaseAlert.error(result.error.message || ApiErrorMessage);
    }
  };

  return (
    <BaseModal
      title="Bullhorn connect"
      maxWidth={454}
      destroyOnClose
      open
      onCancel={handleCloseModal}
    >
      <Formik
        enableReinitialize
        innerRef={formRef}
        validationSchema={validationSchema}
        initialValues={initialValues}
        onSubmit={handleSubmit}
      >
        <Form layout="vertical">
          <div className="modal-scroll-wrapper">
            <div className={styles.box}>
              <img
                src={bullhornLogo}
                alt="bullhorn"
                className={styles.boxImage}
              />
            </div>
            <FormItem name="login" label="Username *">
              <Input name="login" placeholder="Enter user name"
                     autoComplete="off"
              />
            </FormItem>
            <FormItem name="password" label="Password *">
              <Input
                name="password"
                type="password"
                placeholder="Enter password"
                autoComplete="off"
              />
            </FormItem>
          </div>
          <BaseModalFooter>
            <Button onClick={handleCloseModal}>Cancel</Button>
            <SubmitButton type="primary">Connect</SubmitButton>
          </BaseModalFooter>
        </Form>
      </Formik>
    </BaseModal>
  );
}
